import { authActionTypes } from "../constants/authActionTypes";

const initialState = {
  uid: null,
  userData: null,
  isNewUser: false,
};
export const authReducer = (state = initialState, action) => {
  console.log("authReducer:", initialState, action)
  switch (action.type) {
    case authActionTypes.ADD_UID:
      return { ...state, uid: action.payload };
    case authActionTypes.ADD_USER:
      return { ...state, userData: action.payload };
    case authActionTypes.SET_NEW_USER:
      return { ...state, isNewUser: action.payload };
    case authActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
};
